<script lang="ts">
  import {user} from '@/store';
  import {capitalize} from 'lodash';
  import {onDestroy} from 'svelte';

  let selectedLanguage: string | undefined = 'English';

  const languages = ['english', 'dutch', 'french', 'finnish', 'german', 'portuguese', 'russian', 'spanish', 'turkish']
    .sort()
    .map(language => capitalize(language));

  const languageSubscription = user.subscribe(async record => {
    const language = record?.preferences?.language;
    if (!language) {
      selectedLanguage = 'English';
      const payload = {
        language: selectedLanguage
      };

      await user.updatePreferences(payload);
    } else {
      selectedLanguage = language;
    }
  });

  async function updateLanguage(event: Event) {
    const selected = event.target as HTMLSelectElement;
    const payload = {
      language: selected.value
    };

    await user.updatePreferences(payload);
  }

  onDestroy(() => languageSubscription());
</script>

<label for="pick-language" class="block text-sm font-medium text-sermon-base-300 dark:text-zinc-200">Language</label>
<div class="relative flex pt-2">
  <select
    on:change={updateLanguage}
    name="pick-language"
    class="block w-full rounded-lg border border-y border-gray-300 bg-white px-4 py-2.5 text-sermon-base-300 focus:border-primary focus:outline-none focus:ring focus:ring-primary focus:ring-opacity-40 dark:border-zinc-600 dark:bg-zinc-800 dark:text-zinc-200 dark:focus:border-blue-300"
    style="-webkit-appearance: none;"
  >
    {#each languages as language}
      {#if language.toUpperCase() === selectedLanguage?.toUpperCase()}
        <option class="capitalize" value={language} selected>{language}</option>
      {:else}
        <option class="capitalize" value={language}>{language}</option>
      {/if}
    {/each}
  </select>
  <div class="pointer-events-none absolute right-0 top-0 flex h-full w-full items-center justify-end px-4">
    <i class="fa-solid fa-angle-down pt-2" aria-hidden="true"></i>
  </div>
</div>
